import { atom } from "jotai";

// Sets up iframe communication: listens for "iframe-ready" → responds with "canvas:focus-mode"
export const iframeFocusModeSetupSetter = atom(
  null,
  (
    _,
    __,
    { iframe, onReady }: { iframe: HTMLIFrameElement; onReady: () => void },
  ) => {
    const handleMessage = (messageEvent: MessageEvent) => {
      if (messageEvent.data?.event === "iframe-ready") {
        if (iframe.contentWindow) {
          const message = { type: "canvas:focus-mode" };
          iframe.contentWindow.postMessage(message, "*");
        }

        onReady();

        window.removeEventListener("message", handleMessage);
      }
    };

    window.addEventListener("message", handleMessage);
  },
);

iframeFocusModeSetupSetter.debugLabel = "iframeFocusModeSetupSetter";
